var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 16.8882L11.9998 16.8881L11.9997 16.8882L11.3633 16.2518L11.3634 16.2517L5.63604 10.5243L6.27243 9.88786L11.9998 15.6153L17.7272 9.88788L18.3636 10.5243L12.6362 16.2517L12.6364 16.2518L12 16.8882Z",
    fill: "#9654FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecall);
export default __webpack_public_path__ + "static/media/Recall.85b4fb2cd73259d4fb8ff75166c6f02b.svg";
export { ForwardRef as ReactComponent };